import { render, staticRenderFns } from "./work-order-details.html?vue&type=template&id=2cecb6e2&scoped=true&"
import script from "./work-order-details.ts?vue&type=script&lang=js&"
export * from "./work-order-details.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cecb6e2",
  null
  
)

export default component.exports